import { render, staticRenderFns } from "./PORecentlyCreated.vue?vue&type=template&id=15a55b88"
import script from "./PORecentlyCreated.vue?vue&type=script&lang=ts"
export * from "./PORecentlyCreated.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports